import { Box, Text } from "@chakra-ui/layout";

const EditLabels = () => {
    return (
        <Box ml="160px" mt="5%">
            <Text fontSize="2xl">Edit Labels is not available</Text>
        </Box>
    );
}

export default EditLabels;